import { render, staticRenderFns } from "./chooseRootCategory.vue?vue&type=template&id=0106c4d6&scoped=true"
import script from "./chooseRootCategory.vue?vue&type=script&lang=js"
export * from "./chooseRootCategory.vue?vue&type=script&lang=js"
import style0 from "./chooseRootCategory.vue?vue&type=style&index=0&id=0106c4d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0106c4d6",
  null
  
)

export default component.exports